import { FC, memo } from 'react';

import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import Info, { InfoTypes } from '@zvuk-b2b/react-uikit/ui/Info';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';

import useAcceptanceAdvancedModal from '../../model/useAcceptanceAdvancedModal';
import { TEXTS } from './texts';

import styles from './AcceptanceAdvancedModal.module.scss';

const AcceptanceAdvancedModal: FC<ModalProps[ModalTypes.ACCEPTANCE_ADVANCED]> = ({ close, afterClose }) => {
  const {
    hasSberConnection,
    startSigningAcceptanceAdvancedLoading,
    handleRedirectToAcceptanceAdvanced,
    handleClose,
    handleShowBillingPage,
  } = useAcceptanceAdvancedModal({ close, afterClose });

  return (
    <ModalScreen
      title={TEXTS.ACCEPTANCE_ADVANCED_MODAL_TITLE}
      onClose={handleClose}
      contentClassName={styles.acceptanceAdvancedModalContent}
      actionButtons={[
        <Button
          elementId="button_redirect_to_acceptance_advanced_modal"
          key="button_redirect_to_acceptance_advanced_modal"
          type={ButtonType.PRIMARY}
          isLoading={startSigningAcceptanceAdvancedLoading}
          isDisabled={!hasSberConnection}
          onClick={handleRedirectToAcceptanceAdvanced}>
          {TEXTS.ACCEPTANCE_ADVANCED_MODAL_PRIMARY_BUTTON_TEXT}
        </Button>,

        <Button
          elementId="button_redirect_to_billing_page_modal"
          key="button_redirect_to_billing_page_modal"
          type={ButtonType.SECONDARY}
          isLoading={startSigningAcceptanceAdvancedLoading}
          onClick={handleShowBillingPage}>
          {TEXTS.ACCEPTANCE_ADVANCED_MODAL_SECONDARY_BUTTON_TEXT}
        </Button>,
      ]}>
      <div>
        <strong>{TEXTS.ACCEPTANCE_ADVANCED_MODAL_DESCRIPTION_HEADER}</strong>
      </div>

      <div>{TEXTS.ACCEPTANCE_ADVANCED_MODAL_DESCRIPTION}</div>

      {!hasSberConnection && (
        <Info type={InfoTypes.WARNING}>
          <span>{TEXTS.ACCEPTANCE_ADVANCED_MODAL_NO_SBER_CONNECTION_TEXT}</span>
        </Info>
      )}
    </ModalScreen>
  );
};

export default memo(AcceptanceAdvancedModal);
